import React from 'react';
import {
  ADD_CUSTOMER,
  ADD_ROLE,
  VIEW_SERVICE_LIST_FROM,
  ADD_STAFF,
  ADD_VENDOR,
  BOOKING_SUMMARY,
  CHANGE_PASSWORD,
  CUSTOMERS,
  DASHBOARD,
  EDIT_CUSTOMER,
  EDIT_ROLE,
  EDIT_STAFF,
  EDIT_VENDOR,
  PROFILE_UPDATE,
  REPORTS,
  ROLES,
  STAFFS,
  VENDORS,
  VIEW_CUSTOMER,
  VIEW_ROLE,
  VIEW_STAFF,
  VIEW_VENDOR,
  BOOKING_AIRPORT_DETAILS,
  BOOKING_PASSENGER_DETAILS,
  BOOKINGS,
  VIEW_BOOKINGS,
  EDIT_BOOKINGS,
  VIEW_SERVICE,
  EDIT_SERVICE,
  ADD_SERVICE,
  ADD_SERVICE_FORM,
  LOGIN,
  VENDOR_DASHBOARD,
  BILLING_ADDRESS,
  ADD_BILLING_ADDRESS,
  EDIT_BILLING_ADDRESS,
  ADD_AIRPORT,
  AIRPORTS,
  EDIT_AIRPORT,
  VIEW_AIRPORT,
  STAFF_PROFILE_UPDATE,
  SUCCESS_PAGE,
  INSTANT_BOOKING_SUCCESS_PAGE,
  INSTANT_BOOKING_AIRPORT_DETAILS,
  INSTANT_BOOKING_PASSENGER_DETAILS,
  INSTANT_BOOKING_SUMMARY,
  INSTANT_BOOKING_COMPLETED,
  INSTANT_BOOKING_EXISTING_CUSTOMER,
  INVOICES,
  VIEW_INVOICE,
  PAYMENT_FAILURE,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS
} from "./AppRoutes";
import { Route, Routes } from "react-router-dom";
import UpdateVendor from "../../../Screens/Vendors/UpdateVendor";
import VendorRegistration from "../../../Screens/Vendors/VendorRegistration";
import ViewVendor from "../../../Screens/Vendors/viewVendor";
import ChangePassword from "../components/ChangePassword";
import DashboardPage from "../components/DashBoardPage";
import VendorManagementList from "../../../Screens/Vendors/VendorManagementList";
import AddCustomer from "../../../Screens/Customers/AddCustomer";
import CustomerList from "../../../Screens/Customers/CustomerList";
import UpdateCustomer from "../../../Screens/Customers/UpdateCustomer";
import ViewCustomer from "../../../Screens/Customers/ViewCustomer";
import StaffList from "../../../Screens/staffs/StaffList";
import ViewStaff from "../../../Screens/staffs/ViewStaff";
import AddStaff from "../../../Screens/staffs/AddStaff";
import UpdateStaff from "../../../Screens/staffs/UpdateStaff";
import ServiceForms from "../../../Screens/Booking/ServiceForm";
import PassengerDetails from "../../../Screens/Booking/PassengerDetails";
import BookingSummary from "../../../Screens/Booking/BookingSummary";
import AddPermissionsForm from "../../../Screens/Roles/AddRole";
import RolePermissionsList from "../../../Screens/Roles/RolePermissionsList";
import ViewRoleForm from "../../../Screens/Roles/ViewRoleForm";
import EditRoleForm from "../../../Screens/Roles/EditRoleForm";
import ViewService from "../../../Screens/Service/viewService";
import ProfileUpdate from "../components/ProfileUpdate";
import AdminReports from "../../../Screens/Reports/AdminReports";
import ViewServiceList from "../../../Screens/Service/viewServiceList";
import EditService from "../../../Screens/Service/EditService";
import AddService from "../../../Screens/Service/AddService";
import BookingList from "../../../Screens/Booking/BookingsList";
import ViewBooking from "../../../Screens/Booking/ViewBooking";
import EditBooking from "../../../Screens/Booking/EditBooking";
import LoginForm from "../../../redux/auth/components/LoginForm";
import Payments from "../../../Screens/Payment/ViewPaymentList";
import ViewPayment from "../../../Screens/Payment/ViewPayment";
import VendorDashBoard from "../components/VendorDashBoard";
import AddressForm from "../../../Screens/Address/BillingAddress";
import AddAddressForm from "../../../Screens/Address/AddAddress";
import AddAirport from "../../../Screens/Airports/addAirport";
import AirportList from "../../../Screens/Airports/viewAllAirports";
import EditAirport from "../../../Screens/Airports/updateAirport";
import ViewAirport from "../../../Screens/Airports/viewAirport";
import EditBillingAddressForm from "../../../Screens/Address/EditBillingAddressForm";
import SuccessPage from "../../../Screens/Booking/SuccessPage";
import InstantBookingSuccess from "../../../Screens/Booking/InstantBookingSuccess";
import InstantBookingAirportDetails from "../../../Screens/Booking/InstantBookingAirportDetails";
import InstantBookingPassengerDetails from "../../../Screens/Booking/InstantBookingPassengerDetails";
import InstantBookingSummary from "../../../Screens/Booking/InstantBookingSummary";
import InstantBookingCompleted from "../../../Screens/Booking/InstantBookingCompleted";
import CustomerSelectionDialog from "../../../Screens/Booking/CustomerSelectionDialog";
import PaymentSuccess from "../../../Screens/Payment/PaymentSuccess";
import PaymentFailure from "../../../Screens/Payment/PaymentFailure";
import PaymentProcessingPage from "../../../Screens/Payment/PaymentProcessingPage";

const AuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path={DASHBOARD} element={<DashboardPage />} />

      <Route path={VENDOR_DASHBOARD} element={<VendorDashBoard />} />
      <Route path={LOGIN} element={<LoginForm />} />
      <Route path={CUSTOMERS} element={<CustomerList />} />
      <Route path={ADD_CUSTOMER} element={<AddCustomer />} />
      <Route path={EDIT_CUSTOMER} element={<UpdateCustomer />} />
      <Route path={VIEW_CUSTOMER} element={<ViewCustomer />} />
      <Route path={VENDORS} element={<VendorManagementList />} />
      <Route path={ADD_VENDOR} element={<VendorRegistration />} />
      <Route path={VIEW_VENDOR} element={<ViewVendor />} />
      <Route path={EDIT_VENDOR} element={<UpdateVendor />} />
      <Route path={CHANGE_PASSWORD} element={<ChangePassword />} />
      <Route path={STAFFS} element={<StaffList />} />
      <Route path={VIEW_STAFF} element={<ViewStaff />} />
      <Route path={ADD_STAFF} element={<AddStaff />} />
      <Route path={EDIT_STAFF} element={<UpdateStaff />} />
      <Route path={ADD_ROLE} element={<AddPermissionsForm />} />
      <Route path={ROLES} element={<RolePermissionsList />} />
      <Route path={VIEW_ROLE} element={<ViewRoleForm />} />
      <Route path={EDIT_ROLE} element={<EditRoleForm />} />
      <Route path={ADD_SERVICE_FORM} element={<ViewService />} />
      <Route path={PROFILE_UPDATE} element={<ProfileUpdate />} />
      <Route path={STAFF_PROFILE_UPDATE} element={<ProfileUpdate />} />
      <Route path={REPORTS} element={<AdminReports />} />
      <Route path={BOOKING_AIRPORT_DETAILS} element={<ServiceForms />} />
      <Route path={BOOKING_SUMMARY} element={<BookingSummary />} />
      <Route path={BOOKING_PASSENGER_DETAILS} element={<PassengerDetails />} />
      <Route path={ADD_SERVICE} element={<AddService />} />
      <Route path={VIEW_SERVICE} element={<ViewService />} />
      <Route path={VIEW_SERVICE_LIST_FROM} element={<ViewServiceList />} />
      <Route path={EDIT_SERVICE} element={<EditService />} />
      <Route path={ADD_AIRPORT} element={<AddAirport />} />
      <Route path={AIRPORTS} element={<AirportList />} />
      <Route path={`${VIEW_AIRPORT}/:airportId`} element={<ViewAirport />} />

      <Route path={`${EDIT_AIRPORT}/:airportId`} element={<EditAirport />} />

      <Route path={BOOKINGS} element={<BookingList />} />
      <Route path={VIEW_BOOKINGS} element={<ViewBooking />} />
      <Route path={EDIT_BOOKINGS} element={<EditBooking />} />
      <Route path={BOOKING_SUMMARY} element={<BOOKING_SUMMARY />} />
      <Route path={INVOICES} element={<Payments />} />
      <Route path={VIEW_INVOICE} element={<ViewPayment />} />
      <Route path={BILLING_ADDRESS} element={<AddressForm />} />
      <Route path={ADD_BILLING_ADDRESS} element={<AddAddressForm />} />
      <Route
        path={INSTANT_BOOKING_SUCCESS_PAGE}
        element={<InstantBookingSuccess />}
      />
      <Route
        path={INSTANT_BOOKING_AIRPORT_DETAILS}
        element={<InstantBookingAirportDetails />}
      />

      <Route
        path={INSTANT_BOOKING_PASSENGER_DETAILS}
        element={<InstantBookingPassengerDetails />}
      />
      <Route
        path={INSTANT_BOOKING_SUMMARY}
        element={<InstantBookingSummary />}
      />
      <Route
        path={INSTANT_BOOKING_COMPLETED}
        element={<InstantBookingCompleted />}
      />
      <Route
        path={INSTANT_BOOKING_EXISTING_CUSTOMER}
        element={<CustomerSelectionDialog />}
      />
      <Route path={EDIT_BILLING_ADDRESS} element={<EditBillingAddressForm />} />
      <Route path={SUCCESS_PAGE} element={<SuccessPage />} />
      <Route path={PAYMENT_SUCCESS} element={<PaymentSuccess />} />
      <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />

      <Route path={PAYMENT_PROCESSING} element={<PaymentProcessingPage />} />
    </Routes>
  );
};
export default AuthenticatedRoutes;
